import React from 'react';
import backgroundImage from '../img/TAMIDS.png';
import logo from '../img/logo.png';

// For demo purposes - replace with your actual API endpoint
const endpointpath = process.env.REACT_APP_API_BASE_URL;

const SSOLogin = () => {

  const handleLogin = (role) => {
    const loginURL = `${endpointpath}/api/sso/${role.toLowerCase()}`;
    console.log("Redirecting to:", loginURL);
    window.location.href = loginURL;
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@400;600;700&display=swap');
        
        .sso-container {
          min-height: 100vh;
          background: 
            linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.7) 100%),
            url('${backgroundImage}');
          background-size: cover;
          background-position: center;
          background-attachment: fixed;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 40px 20px;
          font-family: 'Urbanist', sans-serif;
          box-sizing: border-box;
        }

        .sso-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(15px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 20px;
          padding: 48px 40px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
          max-width: 500px;
          width: 100%;
          margin: 50px auto;
          text-align: center;
          opacity: 1;
          transform: none;
          transition: none;
        }

        .sso-title {
          font-size: 32px;
          font-weight: 700;
          color: #500000;
          margin-bottom: 16px;
          letter-spacing: -0.5px;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .sso-subtitle {
          font-size: 16px;
          color: #444;
          margin-bottom: 40px;
          line-height: 1.6;
        }

        .button-container {
          display: flex;
          flex-direction: column;
          gap: 16px;
          margin-bottom: 24px;
        }

        .login-btn {
          padding: 16px 32px;
          font-size: 16px;
          font-weight: 600;
          font-family: 'Urbanist', sans-serif;
          border: none;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          position: relative;
          overflow: hidden;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          backdrop-filter: blur(10px);
        }

        .login-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
          transition: left 0.5s;
        }

        .login-btn:hover::before {
          left: 100%;
        }

        .student-btn {
          background: linear-gradient(135deg, #500000, #700000);
          color: #fff;
          box-shadow: 0 4px 15px rgba(80, 0, 0, 0.4);
        }

        .student-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 30px rgba(80, 0, 0, 0.5);
          background: linear-gradient(135deg, #600000, #800000);
        }

        .student-btn:active {
          transform: translateY(-1px);
        }

        .employer-btn {
          background: linear-gradient(135deg, #2c3e50, #34495e);
          color: #fff;
          box-shadow: 0 4px 15px rgba(44, 62, 80, 0.4);
        }

        .employer-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 30px rgba(44, 62, 80, 0.5);
          background: linear-gradient(135deg, #34495e, #3c556f);
        }

        .employer-btn:active {
          transform: translateY(-1px);
        }

        .divider {
          display: flex;
          align-items: center;
          margin: 24px 0;
          color: #666;
          font-size: 14px;
          font-weight: 500;
        }

        .divider::before,
        .divider::after {
          content: '';
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, transparent, #ddd, transparent);
        }

        .divider::before {
          margin-right: 16px;
        }

        .divider::after {
          margin-left: 16px;
        }

        .help-text {
          font-size: 14px;
          color: #666;
          margin-top: 20px;
        }

        .help-link {
          color: #500000;
          text-decoration: none;
          font-weight: 600;
          transition: color 0.3s ease;
        }

        .help-link:hover {
          color: #700000;
          text-decoration: underline;
        }

        /* Floating particles effect */
        .sso-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
                      radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
                      radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
          pointer-events: none;
        }

        @media (max-width: 768px) {
          .sso-container {
            padding: 20px 10px;
            background-attachment: scroll;
          }
          
          .sso-card {
            padding: 32px 24px;
            border-radius: 16px;
            backdrop-filter: blur(10px);
          }
          
          .sso-title {
            font-size: 28px;
          }
          
          .button-container {
            gap: 12px;
          }
          
          .login-btn {
            padding: 14px 28px;
            font-size: 15px;
          }
        }

        @media (max-width: 480px) {
          .sso-card {
            padding: 24px 20px;
            margin: 20px auto;
          }
          
          .sso-title {
            font-size: 24px;
          }
          
          .sso-subtitle {
            font-size: 14px;
          }
        }
      `}</style>
      
      <div className="sso-container">
        <div className="sso-card visible">
          <img 
            src={logo} 
            alt="Data2Reality Logo" 
            style={{ display: "block", margin: "0 auto 20px", maxWidth: "168px" }} 
          />
          <h1 className="sso-title">Welcome to Data2Reality</h1>
          <p className="sso-subtitle">
            Login / Sign up with your Texas A&M credentials to access your account
          </p>
          
          <div className="button-container">
            <button 
              className="login-btn student-btn" 
              onClick={() => handleLogin("Student")}
            >
              Student
            </button>
            
            <button 
              className="login-btn employer-btn" 
              onClick={() => handleLogin("Employer")}
            >
              Employer
            </button>
          </div>
          
          <div className="divider">
            Secure Single Sign-On
          </div>
          
          <p className="help-text">
            Need help? <a href="/contact" className="help-link">Contact Us</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default SSOLogin;